<div class="testimonials-page">

    <!-- =====================================================
         HERO
    ====================================================== -->

    <section class="testimonials-hero">

        <div class="testimonials-container">

            <h1>
                Reviews from across
                <span>the Carolinas</span>
            </h1>

            <p>
                Agents, buyers, sellers, and homeowners across
                the Carolinas count on speKwo.
            </p>

        </div>

    </section>


    <!-- =====================================================
         01 / REAL ESTATE PROFESSIONALS
    ====================================================== -->

    <section class="testimonials-section professionals-section">

        <div class="testimonials-container">

            <div
                class="section-label"
                data-reveal
            >

                <span>
                    01 / REAL ESTATE PROFESSIONALS
                </span>

                <i></i>

            </div>


            <h2>
                Real estate
                <span>professionals</span>
            </h2>


            <div class="reviews-grid">

                <!-- Scott H -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo has helped me buy back precious time
                        in my schedule, at an incredibly low cost.
                        Every quote received has saved me so many
                        hours of time calling and driving to meet
                        contractors. The clients love having a one
                        stop shop for repairs &amp; quotes. If you
                        are a full-time agent, this service is a must,
                        to keep you doing what you do best… selling
                        houses!
                    </blockquote>

                    <figcaption>

                        <img
                            src="https://api.spekwo.com/bannerImages/2/2_Scott%20H.png"
                            alt="Scott H · Trade & Tryon Realty"
                            width="44"
                            height="44"
                        >

                        <span>
                            SCOTT H · TRADE &amp; TRYON REALTY
                        </span>

                    </figcaption>

                </figure>


                <!-- Zann H -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I have been working with spekwo for four
                        years. In that time they have completed
                        repairs for a number of my clients and
                        completed dozens of quotes for me and everyone
                        on my team. We count on them for our
                        transactions.
                    </blockquote>

                    <figcaption>

                        <img
                            src="https://api.spekwo.com/bannerImages/7/7_Zann%20H.png"
                            alt="Zann H · Coldwell Banker"
                            width="44"
                            height="44"
                        >

                        <span>
                            ZANN H. · COLDWELL BANKER
                        </span>

                    </figcaption>

                </figure>


                <!-- Judi S -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I always follow up with my clients after they
                        have work completed with your company and I am
                        yet to have any disappointed clients! Thank
                        you! Your process is easy and convenient to
                        use, which compliments a smooth process for
                        my clients throughout their purchasing
                        process!
                    </blockquote>

                    <figcaption>

                        <img
                            src="https://api.spekwo.com/bannerImages/1/1_Judi%20S.png"
                            alt="Judi S · Keller Williams Ballantyne"
                            width="44"
                            height="44"
                        >

                        <span>
                            JUDI S. · KELLER WILLIAMS BALLANTYNE
                        </span>

                    </figcaption>

                </figure>


                <!-- Claudia O -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I first learned about spekwo when the buyers’
                        agent presented their quote to negotiate
                        repairs. I was the listing agent in that
                        transaction. Because I constantly deal with
                        repairs and also renovations, I have a pretty
                        good idea of what fair and reasonable
                        contractors charge, and spekwo was exactly
                        that. Since then, I have been using them for
                        my client’s deals and highly recommend them.
                    </blockquote>

                    <figcaption>

                        <img
                            src="https://api.spekwo.com/bannerImages/6/6_Claudia%20O.png"
                            alt="Claudia O · Compass"
                            width="44"
                            height="44"
                        >

                        <span>
                            CLAUDIA O. · COMPASS
                        </span>

                    </figcaption>

                </figure>


                <!-- Ryan W -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Having one place I can send the home
                        inspection report to that can assess each
                        item and put a dollar amount on is extremely
                        helpful. My clients really appreciate being
                        able to get the dollar figure quickly to know
                        what was involved (with costs). I cannot say
                        enough great things about your company.
                    </blockquote>

                    <figcaption>

                        <img
                            src="https://api.spekwo.com/bannerImages/4/4_Ryan%20W.png"
                            alt="Ryan W · Boxwood Realty"
                            width="44"
                            height="44"
                        >

                        <span>
                            RYAN W · BOXWOOD REALTY
                        </span>

                    </figcaption>

                </figure>


                <!-- Carolina F -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I love how quickly they can get the quotes
                        back to me, so we can negotiate, and how
                        amazingly fast they can start coordinating the
                        work. They are way more efficient than having
                        multiple people getting you different quotes.
                        I love it!
                    </blockquote>

                    <figcaption>

                        <img
                            src="https://api.spekwo.com/bannerImages/5/5_Carolina%20F.png"
                            alt="Carolina F · Granite Real Estate"
                            width="44"
                            height="44"
                        >

                        <span>
                            CAROLINA F. · GRANITE REAL ESTATE
                        </span>

                    </figcaption>

                </figure>


                <!-- Vivian Z -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo has been really beneficial to my
                        buyers, they love being able to get a quick
                        detailed quote.
                    </blockquote>

                    <figcaption>

                        <img
                            src="https://api.spekwo.com/bannerImages/3/3_Vivian%20Z.png"
                            alt="Vivian Z · Northgroup Real Estate"
                            width="44"
                            height="44"
                        >

                        <span>
                            VIVIAN Z · NORTHGROUP REAL ESTATE
                        </span>

                    </figcaption>

                </figure>


                <!-- Robert Joines -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I cannot recommend Spekwo enough. They are
                        prompt, professional, and incredibly detailed
                        in their work and estimates. I am a realtor
                        who often needs invoices on repairs once a
                        home inspection has been performed. They
                        routinely are able to…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            RJ
                        </span>

                        <span>
                            ROBERT JOINES · REALTOR
                        </span>

                    </figcaption>

                </figure>


                <!-- E Barry -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        As a buyer’s agent, Spekwo’s estimates have
                        helped in negotiating repairs. As a listing
                        agent, my Sellers have had Spekwo take a
                        pre-list inspection and make repairs necessary
                        in order to put it on the market. LOVE Spekwo!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            EB
                        </span>

                        <span>
                            E BARRY · BUYER’S &amp; LISTING AGENT
                        </span>

                    </figcaption>

                </figure>


                <!-- Matthew Masucci -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I’ve had the opportunity to work with Spekwo
                        on two separate real estate transactions, one
                        representing a seller and one representing a
                        buyer, and I can confidently say they are a
                        phenomenal team.…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            MM
                        </span>

                        <span>
                            MATTHEW MASUCCI · AGENT
                        </span>

                    </figcaption>

                </figure>


                <!-- Zack Bonczek -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Shaun and the crew at SpeKwo are a great asset
                        to my real estate sales team! They are prompt
                        with their estimates and perform quality work
                        at a fair price. Accessibility is key in this
                        business and the folks at SpeKwo are prompt
                        in their communications. Highly recommend!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            ZB
                        </span>

                        <span>
                            ZACK BONCZEK · REAL ESTATE SALES TEAM
                        </span>

                    </figcaption>

                </figure>


                <!-- Joanna Dougan -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        As a local Realtor, it’s so helpful to have a
                        resource for buyers and sellers to obtain
                        reasonable pricing, so they can make informed
                        decisions. It’s also helpful to have access to
                        vetted contractors with a company that warrants
                        their work.…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            JD
                        </span>

                        <span>
                            JOANNA DOUGAN · LOCAL REALTOR
                        </span>

                    </figcaption>

                </figure>


                <!-- Joey Lindsey -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I will never use anyone but Spekwo for my
                        Buyers and will use them for my Sellers going
                        forward.
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            JL
                        </span>

                        <span>
                            JOEY LINDSEY
                        </span>

                    </figcaption>

                </figure>


                <!-- Jenny Linich -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo is so easy to work with! A great time
                        saver for agents and their clients. They do
                        everything, repairwise. Their reports are
                        detailed and transparent. And they show up
                        when they say they will and do good work!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            JL
                        </span>

                        <span>
                            JENNY LINICH
                        </span>

                    </figcaption>

                </figure>


                <!-- Jamie Thomas -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo is not only a convenient trusted go to
                        resource for quoting repairs, but the
                        scheduling of repairs is efficient and the
                        repair work that I have seen is completed
                        timely and great quality work!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            JT
                        </span>

                        <span>
                            JAMIE THOMAS
                        </span>

                    </figcaption>

                </figure>


                <!-- Andrew Greenberg -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo is our go to contractor for inspection
                        report quoting and repairs. I really like how
                        they can address a wide variety of projects
                        and how clear and concise their quoting is.
                        They are easy to schedule repairs and check in
                        frequently to answer any questions.…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            AG
                        </span>

                        <span>
                            ANDREW GREENBERG
                        </span>

                    </figcaption>

                </figure>


                <!-- Donald Ellis -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo is an outstanding business partner.
                        They’re fair in every interaction, dependable
                        when it counts, and consistently willing to go
                        the extra mile to get things done. What truly
                        sets them apart is their responsiveness —
                        they’re always…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            DE
                        </span>

                        <span>
                            DONALD ELLIS
                        </span>

                    </figcaption>

                </figure>

            </div>

        </div>

    </section>


    <!-- =====================================================
         02 / BUYERS & SELLERS
    ====================================================== -->

    <section class="testimonials-section buyers-section">

        <div class="testimonials-container">

            <div
                class="section-label"
                data-reveal
            >

                <span>
                    02 / BUYERS &amp; SELLERS
                </span>

                <i></i>

            </div>


            <h2>
                Buyers &amp;
                <span>sellers</span>
            </h2>


            <div class="reviews-grid">

                <!-- Dan S -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Great experience working with the team at
                        Spekwo. They filled the gap between my home
                        inspection, knowing how much each repair would
                        cost, and then having highly qualified
                        professionals show up exactly when scheduled
                        to get the work done well. Highly recommend!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            DS
                        </span>

                        <span>
                            DAN S
                        </span>

                    </figcaption>

                </figure>


                <!-- Kevin Ravens -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        We bought a new home and had the inspection
                        done. They sent us a link with all of the
                        items that came up on the inspection. We
                        clicked all of the items that we wanted done
                        and they sent their guys out to make all of
                        the repairs. We also…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            KR
                        </span>

                        <span>
                            KEVIN RAVENS
                        </span>

                    </figcaption>

                </figure>


                <!-- Christine Isaacs -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        We recently used spekwo to help repair some
                        things that came up in our home inspection
                        (and used their estimate to help negotiate
                        some concessions from the seller).…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            CI
                        </span>

                        <span>
                            CHRISTINE ISAACS
                        </span>

                    </figcaption>

                </figure>


                <!-- Benjamin Turits -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Great experience working with the team at
                        Spekwo. They knocked off all of the items that
                        were flagged on my home inspection, knowing
                        how much each repair would cost, and then
                        having highly qualified professionals show up
                        exactly when…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            BT
                        </span>

                        <span>
                            BENJAMIN TURITS
                        </span>

                    </figcaption>

                </figure>


                <!-- Richard Zeitvogel -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        After purchasing my home and getting an
                        inspection done, Spekwo provided a detailed
                        list of what and how they would perform the
                        repairs with a very reasonable estimate. I
                        simply selected the items that I wanted to
                        repair and they scheduled…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            RZ
                        </span>

                        <span>
                            RICHARD ZEITVOGEL
                        </span>

                    </figcaption>

                </figure>


                <!-- Colin Cumberworth -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        We have had an outstanding experience with
                        everyone that has come out to do work on our
                        house. Our real estate agent recommended them,
                        and we are glad he did. They have been
                        professional, good communicators, and the work
                        has been quality.…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            CC
                        </span>

                        <span>
                            COLIN CUMBERWORTH
                        </span>

                    </figcaption>

                </figure>


                <!-- Jeffrey Brooks -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        What a delightful company to work with. The
                        staff were professional and cleaned up and
                        addressed every need we had while also
                        recommending what things from the inspection
                        report don’t really need changing or they
                        simply made an adjustment and voila it works.
                        Will contract with them again for sure.
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            JB
                        </span>

                        <span>
                            JEFFREY BROOKS
                        </span>

                    </figcaption>

                </figure>


                <!-- Liz Segal -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        As a first time homebuyer, Spekwo made the
                        whole process such a breeze! Three
                        professionals came together to my Durham home
                        to fix all the repairs listed in my inspection
                        report. They were communicative, efficient,
                        and did great work. Highly recommend!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            LS
                        </span>

                        <span>
                            LIZ SEGAL · FIRST-TIME HOMEBUYER, DURHAM
                        </span>

                    </figcaption>

                </figure>


                <!-- Dhwanit Patel -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo did an excellent job handling the
                        closing repairs. They were up to date with all
                        the requests and very transparent in their
                        communication.…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            DP
                        </span>

                        <span>
                            DHWANIT PATEL
                        </span>

                    </figcaption>

                </figure>

            </div>

        </div>

    </section>


    <!-- =====================================================
         03 / REPAIR QUALITY & SERVICE
    ====================================================== -->

    <section class="testimonials-section repair-section">

        <div class="testimonials-container">

            <div
                class="section-label"
                data-reveal
            >

                <span>
                    03 / REPAIR QUALITY &amp; SERVICE
                </span>

                <i></i>

            </div>


            <h2>
                Repair quality &amp;
                <span>service</span>
            </h2>


            <div class="reviews-grid">

                <!-- Thomas Brown -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        This is a great company that is TOTALLY
                        customer focused. Every craftsman was very
                        competent as their tasks. The team lead was
                        outstanding and made sure I was happy with all
                        the work and made adjustments as needed. VERY
                        HAPPY with the repairs/improvements made at my
                        new home!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            TB
                        </span>

                        <span>
                            THOMAS BROWN
                        </span>

                    </figcaption>

                </figure>


                <!-- John Sullivan -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        We were very happy with the work performed on
                        our house by Spekwo. We had a very tight
                        timeframe to get repairs done and they
                        delivered as promised! That is rare and
                        refreshing these days. We also felt the
                        charges were very reasonable.…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            JS
                        </span>

                        <span>
                            JOHN SULLIVAN
                        </span>

                    </figcaption>

                </figure>


                <!-- Joyce Durol -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I’ve had Spekwo do repair work on two of my
                        investment properties in Huntersville. Both
                        times, the work was thorough and completed on
                        time. I like that I am sent photos of the
                        finished product. When I’ve had concerns, Kyren
                        or another…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            JD
                        </span>

                        <span>
                            JOYCE DUROL · INVESTMENT PROPERTY OWNER,
                            HUNTERSVILLE
                        </span>

                    </figcaption>

                </figure>


                <!-- Ryan Rubin -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Kyren has been helpful and easy to work with.
                        I have use them for a few fixes and the company
                        is great. I don’t live locally and it is a
                        rental and they handle everything! Will use
                        again if needed…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            RR
                        </span>

                        <span>
                            RYAN RUBIN · OUT-OF-AREA RENTAL OWNER
                        </span>

                    </figcaption>

                </figure>


                <!-- Eileen Heisman -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        We used Spekwo in Arden NC to fix many issues
                        in a partially flipped house we bought, that
                        appeared to be in good shape. It wasn’t. After
                        a frightening inspection process that pointed
                        out major major home repair issues, Spekwo came
                        to the…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            EH
                        </span>

                        <span>
                            EILEEN HEISMAN · ARDEN, NC
                        </span>

                    </figcaption>

                </figure>


                <!-- AK -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I recently had the extraordinary experience of
                        working with Spekwo for handyman services, and
                        I am beyond impressed! From the very first
                        interaction, Tyler, the project manager
                        assigned to my home, showcased a level of
                        professionalism and…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            A
                        </span>

                        <span>
                            AK
                        </span>

                    </figcaption>

                </figure>


                <!-- Michelle Burris -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        We had Spekwo do a few things on our home and
                        they understood the assignment! Everything
                        that needed to be repaired was checked off on
                        the list and the results were GREAT! The
                        technician Chris was absolutely wonderful! I
                        would suggest everyone to give them a call to
                        set up an appointment because the service was
                        GREAT!!!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            MB
                        </span>

                        <span>
                            MICHELLE BURRIS
                        </span>

                    </figcaption>

                </figure>


                <!-- Sunny Luang -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        We had a great experience with this company.
                        Tyler was absolutely outstanding. He was very
                        friendly, professional, and respectful
                        throughout the entire visit.…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            SL
                        </span>

                        <span>
                            SUNNY LUANG
                        </span>

                    </figcaption>

                </figure>


                <!-- Sam Greenstein -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Tyler and Alex were a great help getting the
                        home I purchased ready to move in. They were
                        thorough, efficient, and very communicable. I
                        would recommend them for your repair needs!
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            SG
                        </span>

                        <span>
                            SAM GREENSTEIN
                        </span>

                    </figcaption>

                </figure>


                <!-- Shawn Fotch -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I had a great experience with Spekwo Home
                        Services. They came out to handle several
                        miscellaneous repairs around my home, and I
                        couldn’t be more pleased with the results.
                        From the initial scheduling to the completion
                        of the work, everything…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            SF
                        </span>

                        <span>
                            SHAWN FOTCH
                        </span>

                    </figcaption>

                </figure>


                <!-- Brian Lawrence -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="100"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        We have used Spekwo multiple times now and
                        have been very happy with the service and work.
                        Shaun just finished a project for us that
                        involved a number of different items ranging
                        in scope, and was very thorough and had great
                        attention to…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            BL
                        </span>

                        <span>
                            BRIAN LAWRENCE
                        </span>

                    </figcaption>

                </figure>


                <!-- Casey Harris -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="200"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo was awesome to work with—great
                        communication, and solid work done when we
                        needed it. Will definitely be using again next
                        time we need general repairs done to the house.
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            CH
                        </span>

                        <span>
                            CASEY HARRIS
                        </span>

                    </figcaption>

                </figure>


                <!-- Judy Haasis -->
                <figure
                    class="review-card"
                    data-reveal
                    data-reveal-delay="0"
                >

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        The Spekwo team was fabulous! I had a long
                        list of projects to be completed once I moved
                        into my new home and they tackled everything
                        with great skill and efficiency. I look forward
                        to having them back to take care of my next
                        ‘to do’ list.…
                    </blockquote>

                    <figcaption>

                        <span class="initial-avatar">
                            JH
                        </span>

                        <span>
                            JUDY HAASIS
                        </span>

                    </figcaption>

                </figure>

            </div>

        </div>

    </section>


    <!-- =====================================================
         CTA
    ====================================================== -->

    <section class="testimonials-cta">

        <div class="testimonials-container">

            <div
                class="cta-box"
                data-reveal
            >

                <div class="cta-content">

                    <h2>
                        Join the agents who
                        <span>stopped chasing contractors.</span>
                    </h2>

                    <p>
                        Get your first neutral quote in 24–72 hours.
                        No calls. No contractor coordination.
                    </p>

                </div>


                <a
                    routerLink="/spekwo-products" [queryParams]="{ product: 'full' }"
                    class="cta-button"
                >
                    Request a Quote →
                </a>

            </div>

        </div>

    </section>

</div>